import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

export const fetchDashboardData = (params) => {
  return Api(endPoints.fetchDashboardData, params, requestType.POST);
};
